var version = "9.18.4";

export { version as v };
//# sourceMappingURL=package-8d7fdc1b.js.map
